import { ListItemButton, ListItemIcon } from '@mui/material';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from '../../redux/store';
import { RouteType } from '../../routes/config';
import React from 'react';
import { colorConfigs } from 'utils/colors';

type Props = {
  item: RouteType;
};

const SidebarItem = ({ item }: Props) => {
  const appState = useSelector((state: RootState) => state.appState);

  return item.sidebarProps && item.path ? (
    <ListItemButton
      component={Link}
      to={item.path}
      sx={{
        '&: hover': {
          color: colorConfigs.sidebar.activeBg,
        },
        width: '90%',
        borderRadius: '0 0 25px 0',
        backgroundColor: String(appState.appState) === item.state ? colorConfigs.sidebar.activeBg : 'unset',
        paddingY: '12px',
        paddingX: '0px',
        marginTop: '8px',
      }}
    >
      <ListItemIcon
        sx={{
          color: colorConfigs.sidebar.color,
        }}
      >
        {item.sidebarProps.icon && item.sidebarProps.icon}
      </ListItemIcon>
      {item.sidebarProps.displayText}
    </ListItemButton>
  ) : null;
};

export default SidebarItem;
